import React from "react";
import LinkComp from "../LinkComp";
import UserProfileDetails from "../UserProfile/UserProfileDetails";

export default () => {
     const isAuthToken = localStorage.getItem("authToken")
  return (
    <header className="Header">
      <div className="Header_wrap">
        <LinkComp className="Header_logo" to={arc.path.base}>
          <img src={arc.path.media + "strive.svg"} alt="" />
        </LinkComp>
        <div className="Header_quote">
          "STRIVE not to be a success, but rather to be of value." - Albert Einstein
        </div>
       {isAuthToken ? <UserProfileDetails/> : null}
      </div>
    </header>
  );
};
